import { render, staticRenderFns } from "./TenderSettings.vue?vue&type=template&id=39ec9ad0&scoped=true&"
import script from "./TenderSettings.vue?vue&type=script&lang=ts&"
export * from "./TenderSettings.vue?vue&type=script&lang=ts&"
import style0 from "./TenderSettings.vue?vue&type=style&index=0&id=39ec9ad0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39ec9ad0",
  null
  
)

export default component.exports